var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, OnDestroy, OnChanges, SimpleChanges, EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import { takeWhile } from 'rxjs/operators';
import { combineLatest } from 'rxjs';
import * as fromStore from '@ibe/store/index';
import * as AncillariesWithMilesActions from '@ibe/store/actions/ancillaries-with-miles.actions';
import { PaymentExtrasMilesComponent } from './payment-extras-miles.component';
import { DomSanitizer } from '@angular/platform-browser';
import { PayAncillariesWithMilesService } from '@ibe.services/mocks.tap/pay-ancillaries-with-miles.service';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import { EXTRAS_ANCILLARY_FAST_TRACK, EXTRAS_ANCILLARY_BAG, EXTRAS_ANCILLARY_LOUNGE, EXTRAS_ANCILLARY_MEAL, EXTRAS_ANCILLARY_MUSICAL, EXTRAS_ANCILLARY_ANIMAL, EXTRAS_ANCILLARY_EQUIPMENT, TRANSLATION_ANCILLARIES_TYPE, EXTRAS_ANCILLARY_SEAT, TAP_HEADER_MILES_AND_GO_MILES, TAP_HEADER_MILES_AND_GO_SILVER, TAP_HEADER_MILES_AND_GO_GOLD, TAP_HEADER_MILES_AND_GO_NAVIGATOR, EXTRAS_ANCILLARY_PREF_BOARD } from '@ibe.config';
import { INDRACurrencyService } from '@ibe.services/currency.indra.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import * as _ from 'lodash';
import { INDRAAncillariesSelectionService } from '@ibe.services/ancillaries-selection.indra.service';
import { INDRABookingService } from '@ibe.services/booking.indra.service';
import { INDRAAncillariesShoppingCartService } from '@ibe.services/ancillaries-shopping-cart.indra.service';
import { PaymentService } from '@ibe.components/shared/payment/payment.service';
import { Router } from '@angular/router';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
var INDRAPaymentExtrasMilesComponent = /** @class */ (function (_super) {
    __extends(INDRAPaymentExtrasMilesComponent, _super);
    function INDRAPaymentExtrasMilesComponent(store, payAncillariesWithMilesService, sanitizer, storageService, currencyService, ibeAdminService, ancillariesSelectionSrv, bookingService, ancillariesShoppingCartSrv, paymentInfoService, router, bfmStorageService) {
        var _this = _super.call(this) || this;
        _this.store = store;
        _this.payAncillariesWithMilesService = payAncillariesWithMilesService;
        _this.sanitizer = sanitizer;
        _this.storageService = storageService;
        _this.currencyService = currencyService;
        _this.ibeAdminService = ibeAdminService;
        _this.ancillariesSelectionSrv = ancillariesSelectionSrv;
        _this.bookingService = bookingService;
        _this.ancillariesShoppingCartSrv = ancillariesShoppingCartSrv;
        _this.paymentInfoService = paymentInfoService;
        _this.router = router;
        _this.bfmStorageService = bfmStorageService;
        _this.hasAPIError = new EventEmitter();
        _this.isAlive = true;
        // User info
        _this.user$ = _this.store.select(fromStore.getUserInfo);
        _this.milesSpent$ = _this.store.select(fromStore.getTotalMilesToSpend);
        _this.milesSpent = 0;
        _this.ancillaryTotalToPay$ = _this.store.select(fromStore.getAncillaryTotalToPay);
        _this.ancillariesTotalDiscount = 0;
        _this.hasError = false;
        _this.hasAncillarieshubAPIError = false;
        _this.bookAwardFlights$ = _this.store.select(fromStore.getFlightsFilterBookAwardFlights);
        _this.hasChanges$ = combineLatest(_this.bookAwardFlights$);
        _this.currency = _this.currencyService.INDRA_getCurrencySymbol().unit;
        _this.user$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.user = value;
            if (!_this.user) {
                _this.milesSpent = 0;
            }
        });
        // /* this.ancillariesAddedToPayWithMiles$
        // 	.pipe(takeWhile(() => this.isAlive))
        // 	.subscribe((value) => {
        // 		if (value) {
        // 			this.ancillariesAddedToPayWithMiles = value;
        // 		}
        // 	}); */
        _this.milesSpent$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.milesSpent = value ? value : 0;
        });
        _this.ancillaryTotalToPay$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.ancillariesTotalDiscount = value && value.miles ? value.miles : 0;
        });
        _this.hasChanges$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (_a) {
            var bookAwardFlights = _a[0];
            _this.bookAwardFlights = bookAwardFlights;
        });
        return _this;
    }
    INDRAPaymentExtrasMilesComponent.prototype.ngOnInit = function () {
        this.booked_trip = this.bfmStorageService.INDRA_getActiveBookedTrip();
    };
    INDRAPaymentExtrasMilesComponent.prototype.ngOnDestroy = function () {
        this.isAlive = false;
    };
    INDRAPaymentExtrasMilesComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        if (changes.ancillaryList) {
            if (!(_.isEqual(changes.ancillaryList.currentValue, changes.ancillaryList.previousValue))) {
                this.ancillaries = _.cloneDeep(this.ancillaryList.filter(function (ancillary) { return ancillary.points; }));
                if (this.hasAncillarieshubAPIError && this.ancillariesWithNoError.length) {
                    this.ancillaries = _.cloneDeep(this.ancillaryList.filter(function (ancillary) { return ancillary.points && _this.ancillariesWithNoError.some(function (a) { return a.code === ancillary.code; }); }));
                    this.hasAncillarieshubAPIError = false;
                }
            }
        }
    };
    INDRAPaymentExtrasMilesComponent.prototype.INDRA_printImage = function (ancillary) {
        var ancillaryId = null;
        switch (ancillary.type) {
            case EXTRAS_ANCILLARY_FAST_TRACK:
                ancillaryId = 'fasttrack';
                break;
            case EXTRAS_ANCILLARY_BAG:
                ancillaryId = 'bags';
                break;
            case EXTRAS_ANCILLARY_LOUNGE:
                ancillaryId = 'lounge';
                break;
            case EXTRAS_ANCILLARY_MEAL:
                ancillaryId = 'meals';
                break;
            case EXTRAS_ANCILLARY_MUSICAL:
                ancillaryId = 'music';
                break;
            case EXTRAS_ANCILLARY_ANIMAL:
                ancillaryId = 'pets';
                break;
            case EXTRAS_ANCILLARY_EQUIPMENT:
                ancillaryId = 'sports';
                break;
            case EXTRAS_ANCILLARY_SEAT:
                ancillaryId = 'seats';
                break;
            case EXTRAS_ANCILLARY_PREF_BOARD:
                ancillaryId = 'preferred';
                break;
        }
        var url = 'url(assets/images/ancillaries/brand-extras/' + ancillaryId + '--small.jpg)';
        var backgroundImageUrl = this.sanitizer.bypassSecurityTrustStyle(url);
        return backgroundImageUrl;
    };
    INDRAPaymentExtrasMilesComponent.prototype.INDRA_ariaLabel = function (ancillary) {
        if (this.user && this.INDRA_hasMilesToPay(ancillary) && !this.INDRA_isAncillarySelected(ancillary)) {
            return 'Use ' + ancillary.points + ' miles to get a ' + this.INDRA_printDiscount(ancillary) + ' and pay for ' + this.INDRA_getAncillaryName(ancillary);
        }
        else {
            return this.INDRA_getAncillaryName(ancillary);
        }
    };
    INDRAPaymentExtrasMilesComponent.prototype.INDRA_printTitle = function (ancillary) {
        return this.INDRA_getAncillaryName(ancillary);
    };
    INDRAPaymentExtrasMilesComponent.prototype.INDRA_printCost = function (ancillary) {
        return ancillary.points + ' M';
    };
    INDRAPaymentExtrasMilesComponent.prototype.INDRA_printDiscount = function (ancillary) {
        return ' | ' + this.currencyService.INDRA_formatCash(ancillary.price) + this.currencyService.INDRA_getCurrencySymbol(ancillary.currency).unit + ' discount';
    };
    INDRAPaymentExtrasMilesComponent.prototype.INDRA_hasMilesToPay = function (ancillary) {
        // tslint:disable-next-line:radix
        if (this.user && this.bookAwardFlights) {
            var limitNegativeMiles = void 0;
            var userMilesBalance = parseInt(this.user.currentPoints);
            var milesCostForBookedTrip = this.booked_trip ? this.booked_trip.data.fare.bookingTotal.miles : 0;
            var milesCostForAddedAnc = ancillary.points;
            switch (this.user.ffLevel) {
                case TAP_HEADER_MILES_AND_GO_MILES:
                    limitNegativeMiles = 500;
                    break;
                case TAP_HEADER_MILES_AND_GO_SILVER:
                    limitNegativeMiles = 5000;
                    break;
                case TAP_HEADER_MILES_AND_GO_GOLD:
                    limitNegativeMiles = 10000;
                    break;
                case TAP_HEADER_MILES_AND_GO_NAVIGATOR:
                    limitNegativeMiles = 20000;
                    break;
                default:
                    limitNegativeMiles = 0;
            }
            var remainingMilesToPay = (userMilesBalance + limitNegativeMiles) - (milesCostForBookedTrip + milesCostForAddedAnc);
            if (remainingMilesToPay < 0) {
                this.hasEnoughMilesFlag = false;
                return false;
            }
            else {
                this.hasEnoughMilesFlag = true;
                return true;
            }
        }
        else {
            if (this.user) {
                return parseInt(this.user.currentPoints) - this.milesSpent >= ancillary.points;
            }
            else {
                return false;
            }
        }
    };
    INDRAPaymentExtrasMilesComponent.prototype.INDRA_printCount = function (ancillary) {
        if (ancillary.count > 1) {
            return ancillary.count + 'X';
        }
        return '';
    };
    INDRAPaymentExtrasMilesComponent.prototype.INDRA_addAncillary = function (ancillary) {
        var _this = this;
        if ((this.user && this.INDRA_hasMilesToPay(ancillary)) || this.INDRA_isAncillarySelected(ancillary)) {
            var milesNeeded_1 = 0;
            var shoppingCartContent_1 = this.storageService.get('INDRAAncillariesShoppingCartService.shoppingCart');
            var isPayWithMiles = void 0;
            if (shoppingCartContent_1) {
                var itemsAdded_1 = shoppingCartContent_1.itemsAdded;
                if (itemsAdded_1.length != 0) {
                    for (var i in itemsAdded_1) {
                        if (itemsAdded_1[i].type == ancillary.type) {
                            itemsAdded_1[i].payWithMiles = !ancillary.payWithMiles;
                            isPayWithMiles = !ancillary.payWithMiles;
                        }
                        if (itemsAdded_1[i].payWithMiles) {
                            milesNeeded_1 = milesNeeded_1 + itemsAdded_1[i].points;
                        }
                    }
                    var ancillaryToUpdate_1 = shoppingCartContent_1.itemsAdded.filter(function (item) {
                        if (item.type === ancillary.type)
                            return item;
                    });
                    var pnr = this.bookingService.getCurrentPNR();
                    this.ancillariesSelectionSrv.INDRA_addAncillariesSelectionItems(ancillaryToUpdate_1);
                    this.ancillariesSelectionSrv.INDRA_updateAncillariesPaymentType(pnr, isPayWithMiles, ancillaryToUpdate_1).subscribe(function (res) {
                        if (res.status === '200') {
                            _this.hasError = false;
                            var totalMiles = (_this.milesSpent - _this.ancillariesTotalDiscount) + milesNeeded_1;
                            shoppingCartContent_1.itemsAdded = itemsAdded_1;
                            _this.storageService.set('INDRAAncillariesShoppingCartService.shoppingCart', shoppingCartContent_1);
                            _this.store.dispatch(new AncillariesWithMilesActions.PutProcessAncillary(totalMiles));
                            // this.store.dispatch(new AncillariesWithMilesActions.PutFlightMilesDiscountAction(totalMiles));
                            // update ancillaries observables on ancillaires-shopping-cart
                            _this.ancillariesShoppingCartSrv.INDRA_updateAncillaries(ancillaryToUpdate_1);
                            _this.INDRA_triggerBookingTotalsUpdate();
                        }
                        else if (res.status === '404' || res.status === '500') {
                            _this.hasError = true;
                            _this.INDRA_handleAncillaryHubError(shoppingCartContent_1, ancillaryToUpdate_1);
                        }
                        else {
                            _this.hasError = true;
                            _this.INDRA_triggerBookingTotalsUpdate();
                            console.log('[Error Ancillaries Payment Type update]:' + (res.errors && res.errors.length > 0 && res.errors[0] ? res.errors[0].desc : ''));
                        }
                    }, function (error) {
                        _this.hasError = true;
                        console.log('[Error Ancillaries Payment Type update]:' + error.details);
                        _this.INDRA_handleAncillaryHubError(shoppingCartContent_1, ancillaryToUpdate_1);
                    });
                }
            }
        }
    };
    INDRAPaymentExtrasMilesComponent.prototype.INDRA_printTooltip = function (ancillary) {
        if (!this.user) {
            return 'You need to login or create an account first  in order to user this discount.';
        }
        else {
            return 'You don’t have enough remaining miles do use this discount.';
        }
    };
    INDRAPaymentExtrasMilesComponent.prototype.INDRA_isAncillarySelected = function (ancillary) {
        return ancillary.payWithMiles;
    };
    INDRAPaymentExtrasMilesComponent.prototype.INDRA_getAncillaries = function () {
        var itemsAdded = this.storageService.get('INDRAAncillariesShoppingCartService.shoppingCart');
    };
    INDRAPaymentExtrasMilesComponent.prototype.INDRA_hasAncillaries = function () {
        if (this.ancillaries.length == 0) {
            return false;
        }
        return true;
    };
    INDRAPaymentExtrasMilesComponent.prototype.INDRA_getAncillaryName = function (ancillary) {
        if (ancillary.type === EXTRAS_ANCILLARY_PREF_BOARD) {
            return this.INDRA_getTranslation("" + (TRANSLATION_ANCILLARIES_TYPE + 'PREFBOARD'));
        }
        else {
            return this.INDRA_getTranslation("" + (TRANSLATION_ANCILLARIES_TYPE + ancillary.type));
        }
    };
    INDRAPaymentExtrasMilesComponent.prototype.INDRA_getTranslation = function (key) {
        return this.ibeAdminService.getTranslationValue(key);
    };
    INDRAPaymentExtrasMilesComponent.prototype.INDRA_handleAncillaryHubError = function (shoppingCart, ancillary) {
        this.hasAncillarieshubAPIError = true;
        this.ancillariesWithNoError = shoppingCart.itemsAdded.filter(function (anc) { return anc.code != ancillary[0].code; });
        this.ancillariesShoppingCartSrv.INDRA_deleteAncillaries(ancillary);
        this.INDRA_triggerBookingTotalsUpdate();
        if (this.router.url.search('payment') >= 0) {
            this.hasAPIError.emit(true);
        }
    };
    INDRAPaymentExtrasMilesComponent.prototype.INDRA_triggerBookingTotalsUpdate = function () {
        if (this.router.url.includes('review-your-trip')) {
            this.paymentInfoService.setUpdateBookingTotals(true);
        }
    };
    return INDRAPaymentExtrasMilesComponent;
}(PaymentExtrasMilesComponent));
export { INDRAPaymentExtrasMilesComponent };
